import React from "react";
import "./PageTop.css";

const PageTop = ({ title,image }) => {
  return (
    <div
      className="page-title-area overlay-bg style-1 top-image"
      style={{
        background: `linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1))`,
        backgroundPosition:'center center',
        backgroundRepeat:'no-repeat',        
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <h3 className="title">{title}</h3>
        </div>
      </div>
    </div>
  );
};

export default PageTop;
